<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <el-dialog :visible.sync="dialogTableVisible">
        <template slot="title">库存商品选择框</template>
        <div class="search">
                 <el-select v-model="value" placeholder="按名称查询">
    <el-option label="按名称查询" value="按名称查询">
    </el-option>
  </el-select><input type="text">
        </div>
      </el-dialog>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <div class="block">
            <span class="title" style="color: blue">供货单位</span>
            <el-input v-model="contactOrganName" class="native"></el-input>
            <span class="title">经手人</span>
            <el-input v-model="hander" class="native"></el-input>
            <span
              class="title"
              style="display: inline-block; margin-right: 10px"
              >交货日期</span
            >
            <el-date-picker v-model="deliveryDate" type="date"> </el-date-picker>
            <button   @click="save" class="native_button" style="background:#f59a23">保存</button>
            <button  @click="checkData" class="native_button" style="background:#f59a23">审核</button>
          </div>
        </el-col>
        <!-- <el-col></el-col> -->
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style="margin-top: 20px">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :header-cell-style="{
                background: '#f59a23',
                color: '#fff',
              }"
              :data="tableData"
              border
              fit
              highlight-current-row
              :row-class-name="tableRowClassName"
              @sort-change="sortChange"
            >
              <el-table-column type="index" fixed align="center">
                <template slot="header"
                  ><i class="el-icon-s-tools"></i
                ></template>
              </el-table-column>
              <el-table-column label="删除" align="center" prop="" width="50px">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.billTime }}</span> -->
                  <i
                  @click="deleteOne(scope.$index)"
                    class="el-icon-delete"
                    title="删除"
                    style="color: #f59a23; font-size: 18px;cursor: pointer;"
                  ></i>
                </template>
              </el-table-column>
              <el-table-column
                label="商品编号"
                align="center"
                prop="productCode"
                width="180px"
              >
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.billNumber }}</span> -->
                  <div style="position: relative">
                    <el-input 
                    readonly
                    v-model="scope.row.productCode"
                    @focus="inputFocus(scope, 1)"></el-input
                    ><strong
                    @click="showDialog(scope.row.categoryCode,scope.row.productName)"
                      v-show="row == scope.$index && column == 1"
                      style="
                        position: absolute;
                        right: 6px;
                        height: 30px;
                        line-height: 30px;
                        cursor: default;
                      "
                      >···</strong
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="商品名称"
                align="center"
                prop="productName"
                width="200px"
              >
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.contactOrganName }}</span> -->
                  <div style="position: relative">
                    <el-input 
                    readonly
                     v-model="scope.row.productName"
                    @focus="inputFocus(scope, 2)"></el-input
                    ><strong
                    @click="showDialog"
                      v-show="row == scope.$index && column == 2"
                      style="
                        position: absolute;
                        right: 6px;
                        height: 30px;
                        line-height: 30px;
                        cursor: default;
                      "
                      >···</strong
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="数量"
                align="center"
                prop="productCount"
                width="140px"
              >
                <template slot-scope="scope">
                  <div style="position: relative">
                    <el-input v-model="scope.row.num"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="进货价"
                align="center"
                prop="purchasePrice"
                width="100px"
              >
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.hander }}</span> -->
                  <div style="position: relative">
                    <el-input v-model="scope.row.purchasePrice"></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="规格"
                width="100px"
                align="center"
                prop="size"
              >
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="型号"
                width="100px"
                align="center"
                prop="type"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="批次号" align="center" prop="批次号">
                <template slot-scope="scope">
                  <span v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="单位">
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="单位关系">
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" width="120px" label="辅助单位1">
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input ></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="辅助单位2">
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="状态">
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input></el-input>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="备注">
                <template slot-scope="scope">
                  <span  v-if="scope.row.$index==-1"></span>
                  <div style="position: relative">
                    <el-input></el-input>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-row></el-scrollbar
        >

    


      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <div style="margin-top: 16px">合计</div>
        <!-- <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination> -->
      </div>
    </el-card>

    <DishesDialog :dishesDialogVisible="dialogShow"
   :selectType="''" :defoultSelect='selected' @handleDishesClose='dishesDialogClose'>
   </DishesDialog>
  
  </div>
</template>

<script>
import drag from "./drag" // 拖拽
import DishesDialog from '../../merchantDiscountCreate/components/DishesDialog.vue';
export default {
  components:{
DishesDialog
  },
  data() {
    return {
      enterBillCode:'',
      hander:'',
      contactOrganName:'',
      selected:[],
      dialogShow:false,
      leftCategory:[],
      detailTableDataRight:[{label:'1',value:2}],
      searchValue:'',// 搜索框
      value:'',
      options:[{label:'按名称查询',value:''}],
      // 
      deliveryDate:'', //交货日期
      dialogVisibleDetail:false,  // ...详情
      dialogTableVisible: false,
      row: "",
      column: "",
      height: window.innerHeight - 256, //表格高度
      value: "",
      dateRange: "",
      endDate: "",
      startDate: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          merchantCode:"",
          categoryCode:"",
          id: "",
          endDt: "",
          startDt: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.queryInfo.condition.merchantCode=localStorage.getItem('merchantCode')
    // this.getListData();
    this.tableDataList();
    this.getLastData()
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
   async getLastData(){
    let res=await this.$http.post('purchaseEnterBill/loadLastBill',{companyCode:localStorage.getItem('merchantCode'),companyName:localStorage.getItem('merchantName')})
   console.log(res)
  if(res.data.data!=null){ 
       this.hander=res.data.data.hander
   this.enterBillCode=res.data.data.enterBillCode
   this.contactOrganName=res.data.data.contactOrganName
   let arr=res.data.data.purchaseEnterBillDetailList
   arr.forEach((item,index)=>{
    this.$set(this.tableData[index],'productCode',item.productCode)
    this.$set(this.tableData[index],'productName',item.productName)
    this.$set(this.tableData[index],'num',item.num)
    this.$set(this.tableData[index],'purchasePrice',item.purchasePrice)
   })
  }else{

  }
   },
  checkData(){
    if(!this.enterBillCode){
      this.$message.error('请先保存入库单')
      return
    }
    this.$confirm('审核订单同时更新库存？', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let obj={}
          obj.companyCode=localStorage.getItem('merchantCode')
          obj.companyName=localStorage.getItem('merchantName')
          obj.enterBillCode=this.enterBillCode
      this.$http.post('purchaseEnterBill/purchaseEnterBillAudit',obj).then(res=>{
        this.checkLoading=false
        if(res.data.code==200){
          this.$message({
          type:'success',
          message:'审核成功'
        })
      //  this.getLastData()
     location.reload()
      
        }else{
          this.$message.error(res.data.message)
        }
      })
        }).catch(() => {

        });
   },
    dishesDialogClose(bool,val,type){
      var start
      let arr=val
      this.dialogShow=false
   let codeIndex = this.tableData.findIndex(i=>{
        return i.productCode==null
      })
      let nameIndex=this.tableData.findIndex(_=>{
        return _.productName==null
      })
      codeIndex< nameIndex?  start=codeIndex: start=nameIndex
      console.log(start)
      let index=start
      for(let j=0;j<arr.length;j++){
       this.$set(this.tableData[index],'productCode',arr[j].productCode)
       this.$set(this.tableData[index],'productName',arr[j].productName)
       index++
      }
    },
        showDialog(a,b){
      this.dialogShow=true
    },
    // 保存
   async save(){
    //校验
    let arr=[]
    this.tableData.forEach(item=>{
      if(item.productCode || item.productName || item.num || item.purchasePrice){
        arr.push(item)
      }
    })
    console.log(arr) //选取实际数组长度
    var flag=true
    for(let i=0;i<arr.length;i++){
      if( !(arr[i].productCode && arr[i].productName)){  //
        this.$message.error('进货单不能为空')
        flag=false
        return
      }
   }
  //  价格与数量
      for(let i=0;i<arr.length;i++){
      if( !(arr[i].num && arr[i].purchasePrice)){  //
        this.$message.error('进货数量及价格不得为空')
        flag=false
        return
      }
   }
   arr.forEach(it=>{
    delete it.type
   })
   let obj={}
   obj.purchaseEnterBillDetailList=arr
   obj.contactOrganName=this.contactOrganName
   obj.hander=this.hander
   obj.companyCode=localStorage.getItem('merchantCode')
   obj.companyName=localStorage.getItem('merchantName')
    let res=await this.$http.post('purchaseEnterBill/purchaseEnterBillSave',obj)
    if(res.data.code==200){
      this.enterBillCode=res.data.data.enterBillCode
     this.$notify.success({
                title: "提示",
                message: "保存成功",
                showClose: true,
            })
    }else{
      this.$message.error(res.data.message)
    }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantOrder/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize,
        },
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantOrders/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode =
        localStorage.getItem("merchantCode");
      that.$http
        .post("/purchaseEnterBills/list", that.queryInfo)
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.count;
            that.queryInfo.currPage = response.data.data.currPage;
            that.tableData = response.data.data.data;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    // 表格样式
    tableRowClassName() {
      return "#ffffff";
    },
    tableDataList() {
      for (var i = 1; i < 41; i++) {
        this.tableData.push({ type: i });
      }
    },
    inputFocus(index, type) {
      this.row = index.$index;
      this.column = type;
      console.log(index.$index, type);
     
    },
    deleteOne(index){
      this.tableData.splice(index,1)
    },
    getLeft(){
      this.$http.post('/merchantProductsCategory/queryList',{merchantCode:localStorage.getItem('merchantCode')}).then(res=>{
        console.log(res,'左侧列表')
        this.leftCategory=res.data.data
      })
    }
  },
};
</script>

<style lang="less" scoped>
.block {
  display: flex;
  .title {
    font-size: 12px;
    line-height: 30px;
    text-align: center;
  }
}
.search-btn {
  display: flex;
  margin-left: 10px;
}
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
.native_button {
  display: inline-block;
  background-color: #1e9fff;
  margin-left: 8px;
  color: #fff;
  border: none;
  width: 44px;
  height: 30px;
  line-height: 30px;
  font-size: 12px;
  padding: 0 5px;
  border-radius: 2px;
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .native {
  width: 200px;
  padding-left: 10px;
  margin-right: 10px;
}
/deep/ .el-table__body tr.current-row > td {
  background-color: #fff;
}
// /deep/ .el-dialog__header {
//   background-color: #1e9fff;
//   padding: 10px 20px;
//   color: #fff;
// }

// input边框
/deep/ .el-table__body .el-input__inner{
    border-color: transparent;
}
// input的focus效果
/deep/ .el-table__body input.el-input__inner:focus{
  border: 1px solid skyblue !important;
}
// 悬浮效果
/deep/ tr:hover>td {
background-color:#fff !important //修改成自己想要的颜色即可
        }
/deep/ .hover-row{
          background-color:#fff !important 
        }
        /deep/ tr:hover{
           background-color:#fff !important 
        }
        .diag-body{
          display: flex;
          align-items: center;
          
        }
        /deep/ .diag-body .el-input{
          width: 120px;
          margin-left: 10px;
        }
        .box-left{
          height: 330px;
          width: 230px;
          margin: 0 10px;
          margin-top: 10px;
          border: 1px solid #cfcfcf;
          overflow: auto;
          .item{
     padding: 3px 0;
     padding-left: 10px;
    height: 20px;
    display: flex;
    align-items: center;
    span{
      margin-left: 10px;
    }
          }
          .item:hover span{
            border-bottom: 1px solid #333;
            cursor: pointer;
          }
        }
        .box-left::-webkit-scrollbar-thumb {
    background-clip: padding-box;
    min-height: 28px;
    -webkit-border-radius: 2em;
    -moz-border-radius: 2em;
    border-radius: 2em;
        background-color: #ddd;
    border-radius: 8px;
    box-shadow: inset 0 0 6px rgba(111, 111, 111, 0.3);

}
.box-left::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}
.box-left::-webkit-scrollbar-button {
    height: 10px;
    width: 10px;
}
/deep/ .el-dialog__body{
  padding: 5px 0;
}
.box-right{
   height: 330px;
   width: 499px;
  margin: 0 10px;
  margin-top: 10px;
  border: 1px solid #cfcfcf;
   overflow: auto;
}
/deep/ .box-right .el-table{
  margin-top: 0;
}
// /deep/ .box-right .el-table-column--selection .cell{
//   padding-left: 10px !important;
// }
/deep/ .el-dialog__headerbtn{
  position: sticky;
  i{
    color: black;
    font-size: 18px;
  }
  i:hover{
    color: black;
  }
}
/deep/ .el-dialog__header{
  display: flex;
  justify-content: space-between;
}
// /deep/ .cell{
//   padding-left: 0;
//   padding-right: 0;
// }
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
background-color: #ffbd00;
    border-color: #ffbd00;
}
</style>

